import { Document, Page, View, Text, Image } from "@react-pdf/renderer";
import actaStyles from "./actaStyles";
import logoArt from "../../../../assets/logos/ART_logo.png";
import logoCampo from "./assets/logo-campo.png";
import logosConvenio from "../../../../assets/logo_exportable/logo.jpg";

const CLAUSULAS = [
  "Los bienes recibidos serán de uso exclusivo y para los fines, propósitos y necesidades que se pretenden satisfacer con la ejecución del proyecto de la referencia, el cual fue concebido para obtener un beneficio tangible para la comunidad.",
  "Ningún particular podrá apropiarse de los bienes recibidos, por tener un uso, destinación y finalidad específica trazada en el mismo.",
  "Está prohibida la venta o cualquier forma de comercialización de los bienes recibidos, por cuánto éstos buscan satisfacer las necesidades identificadas en la formulación del proyecto, salvo disposición contraria contemplada dentro del proyecto.",
  "Se compromete, acepta y entiende, las implicaciones de la administración e incluso las responsabilidades tributarias que se desprenden de la recepción de los bienes entregados.",
  "Se compromete a darle buen uso al bien transferido en especial, a no usarlo(s) para ningún fin ilícito.",
  "Se compromete a vincular y controlar tanto a sus activos como su partida patrimonial de los activos productivos entregados con el fin de mantener en el tiempo, su sostenibilidad financiera como existencia de estos.",
  "Los bienes entregados deben ser reconocidos en la contabilidad de la organización, cuando aplique."
];

export default function ActaIndividualPDF({ data }) {
  const {
    codigoConvenio,
    nombreProyecto,
    tipoActa,
    fechaEntrega,
    departamento,
    municipio,
    vereda,
    lugarEntrega,
    nombreBeneficiario,
    identificacion,
    telefono,
    objetivo,
    bienes,
    usuarioEntrega,
    usuarioSupervisor
  } = data;

  return (
    <Document>
      <Page size="A4" style={actaStyles.page}>
        <View style={actaStyles.headerRow}>
          <Text style={[actaStyles.headerTitulo, actaStyles.headerTextBlock]}>{codigoConvenio}</Text>
          <Image src={logoArt} style={actaStyles.headerLogo} />
        </View>
        <Text style={actaStyles.subtitulo}>{nombreProyecto}</Text>
        <Text style={actaStyles.actaTitulo}>Acta de entrega de bienes - Individual</Text>

        <View style={actaStyles.infoTable}>
          <View style={actaStyles.infoRow}>
            <Text style={actaStyles.infoLabel}>Nombre del proyecto:</Text>
            <Text style={actaStyles.infoValue}>{nombreProyecto}</Text>
          </View>
          <View style={actaStyles.infoRow}>
            <Text style={actaStyles.infoLabel}>Tipo de entrega:</Text>
            <Text style={actaStyles.infoValue}>{tipoActa}</Text>
          </View>
          <View style={actaStyles.infoRow}>
            <Text style={actaStyles.infoLabel}>Fecha de entrega:</Text>
            <Text style={actaStyles.infoValue}>{fechaEntrega}</Text>
          </View>
          <View style={actaStyles.infoRow}>
            <Text style={actaStyles.infoLabel}>Departamento:</Text>
            <Text style={actaStyles.infoValue}>{departamento}</Text>
          </View>
          <View style={actaStyles.infoRow}>
            <Text style={actaStyles.infoLabel}>Municipio:</Text>
            <Text style={actaStyles.infoValue}>{municipio}</Text>
          </View>
          <View style={actaStyles.infoRow}>
            <Text style={actaStyles.infoLabel}>Vereda:</Text>
            <Text style={actaStyles.infoValue}>{vereda || "N/A"}</Text>
          </View>
          <View style={actaStyles.infoRow}>
            <Text style={actaStyles.infoLabel}>Lugar de entrega:</Text>
            <Text style={actaStyles.infoValue}>{lugarEntrega || municipio}</Text>
          </View>
          <View style={actaStyles.infoRow}>
            <Text style={actaStyles.infoLabel}>Nombres y apellidos beneficiario/a:</Text>
            <Text style={actaStyles.infoValue}>{nombreBeneficiario}</Text>
          </View>
          <View style={actaStyles.infoRow}>
            <Text style={actaStyles.infoLabel}>Identificación:</Text>
            <Text style={actaStyles.infoValue}>{identificacion}</Text>
          </View>
          <View style={actaStyles.infoRowLast}>
            <Text style={actaStyles.infoLabel}>Teléfono de contacto:</Text>
            <Text style={actaStyles.infoValue}>{telefono || "N/A"}</Text>
          </View>
        </View>

        <Text style={actaStyles.seccionTitulo}>OBJETIVO</Text>
        <Text style={actaStyles.parrafo}>{objetivo}</Text>

        <Text style={actaStyles.seccionTitulo}>DESARROLLO</Text>
        <Text style={actaStyles.parrafo}>
          En el marco del convenio {codigoConvenio}, se hace entrega al/a la beneficiario(a) cuyo nombre y número
          de identificación están descritos en esta acta.
        </Text>

        <Text style={actaStyles.seccionTitulo}>PRIMERO. Descripción del bien entregado.</Text>
        <Text style={actaStyles.parrafo}>
          Con la firma de la presente acta se hace entrega formal en {lugarEntrega || municipio}, municipio de{" "}
          {municipio}, departamento de {departamento}, al señor(a) {nombreBeneficiario}, de los bienes que a
          continuación se describen:
        </Text>

        <View style={actaStyles.bienesTable}>
          <View style={actaStyles.bienesHeaderRow}>
            <Text style={actaStyles.bienesCellNo}>No.</Text>
            <Text style={actaStyles.bienesCellBien}>Bien</Text>
            <Text style={actaStyles.bienesCellSerial}>Serial(es)</Text>
            <Text style={actaStyles.bienesCellCantidad}>Cantidad</Text>
            <Text style={actaStyles.bienesCellDescripcion}>Descripción</Text>
            <Text style={actaStyles.bienesCellObs}>Unidad</Text>
          </View>
          {bienes.map((b, i) => (
            <View style={actaStyles.bienesRow} key={i}>
              <Text style={actaStyles.bienesCellNo}>{i + 1}</Text>
              <Text style={actaStyles.bienesCellBien}>{b.nombre_corto || b.tipo_producto}</Text>
              <Text style={actaStyles.bienesCellSerial}>N/A</Text>
              <Text style={actaStyles.bienesCellCantidad}>{b.cantidad}</Text>
              <Text style={actaStyles.bienesCellDescripcion}>{b.nombre_producto}</Text>
              <Text style={actaStyles.bienesCellObs}>{b.unidad_medida}</Text>
            </View>
          ))}
        </View>

        <Text style={actaStyles.seccionTitulo}>SEGUNDO. Recibo a satisfacción:</Text>
        <Text style={actaStyles.parrafo}>
          Con la firma de esta acta el(la) señor(a) {nombreBeneficiario} manifiesta que recibe conforme a las
          características técnicas y cantidades del plan de inversión acordado.
        </Text>

        <Text style={actaStyles.seccionTitulo}>TERCERO. Condiciones de la entrega:</Text>
        <View style={actaStyles.clausulasLista}>
          {CLAUSULAS.map((texto, i) => (
            <View style={actaStyles.clausulaItem} key={i}>
              <Text style={actaStyles.clausulaLetra}>{String.fromCharCode(97 + i)})</Text>
              <Text style={actaStyles.clausulaTexto}>{texto}</Text>
            </View>
          ))}
        </View>

        <Text style={actaStyles.seccionTitulo}>CUARTO. Eximente de responsabilidad</Text>
        <Text style={actaStyles.parrafo}>
          El(la) señor(a) {nombreBeneficiario} exime de cualquier responsabilidad originada en el bien
          transferido. Una vez firmada esta acta, quedará exenta de cualquier reclamación originada en el bien
          entregado.
        </Text>
        <Text style={actaStyles.parrafo}>
          En constancia de lo anterior, se firma la presente acta en {lugarEntrega || municipio}, municipio de{" "}
          {municipio}, departamento de {departamento}, el {fechaEntrega}.
        </Text>

        <View style={actaStyles.firmasRow}>
          <View style={actaStyles.firmaBox}>
            <Text style={actaStyles.firmaLabel}>Recibe</Text>
            <Text style={actaStyles.firmaTexto}>{nombreBeneficiario}</Text>
            <Text style={actaStyles.firmaTexto}>C.C. {identificacion}</Text>
          </View>
          <View style={actaStyles.firmaBox}>
            <Text style={actaStyles.firmaLabel}>Entrega</Text>
            <Text style={actaStyles.firmaTexto}>{usuarioEntrega || "________________"}</Text>
          </View>
          <View style={actaStyles.firmaBox}>
            <Text style={actaStyles.firmaLabel}>Supervisor convenio</Text>
            <Text style={actaStyles.firmaTexto}>{usuarioSupervisor || "________________"}</Text>
          </View>
        </View>

        <View style={actaStyles.footer} fixed>
          <View style={actaStyles.footerRow}>
            <Image src={logoCampo} style={actaStyles.footerLogoCampo} />
            <Image src={logosConvenio} style={actaStyles.footerLogoConvenio} />
          </View>
        </View>
      </Page>
    </Document>
  );
}
